import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";

export const getSessionCountry = (): keyof typeof ISO3166Alpha3 | undefined => {
  return getGlobalProperty<keyof typeof ISO3166Alpha3>("sessionCountry");
};
